import script from "./ModalContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalContainer.vue?vue&type=script&setup=true&lang=js"

import "./ModalContainer.vue?vue&type=style&index=0&id=d9c2990e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9c2990e"]])

export default __exports__